export const defaultStyle = {
    heading: "headline4",
    wrapper: "grow pt-[24px] border-b-[1px] border-black",
    block: "flex flex-col space-y-[48px] text-body-m border-t-[1px] border-black py-[24px] mt-[24px] lg:py-[32px] lg:mt-[32px]",
    itemHeadline: "body-m font-semibold ",
    item: "flex space-x-[10px] body-m font-normal",
    icon: "mt-[5px] w-[12px] h-[12px] circle-icon-shadow rounded-[100%] bg-red border-none border-[1px] border-black shrink-0",
}
